import { axiosInstance } from '.'
import type {
  InvestmentLimitRequestDetail,
  InvestmentLimitRequestListItem,
  InvestmentLimitRequestReviewPayload,
  InvestmentLimitRequestReviewResult,
  InvestmentLimitRequestSearchParams,
} from '../lib/types'
import { removeEmptyValueFromObject } from '../lib/utils/helpers'
import {
  GET_INVESTMENT_LIMIT_REQUEST_V1,
  LIST_INVESTMENT_LIMIT_REQUESTS_V1,
  UPDATE_INVESTMENT_LIMIT_REQUEST_V1,
} from './endpoints'

export const investmentLimitRequestServices = {
  list: async (
    params: InvestmentLimitRequestSearchParams = {},
  ): Promise<{
    data: InvestmentLimitRequestListItem[]
    total: number
    status: number
    message?: string
  }> => {
    try {
      const response = await axiosInstance.get<{
        data: InvestmentLimitRequestListItem[]
        total: number
      }>(LIST_INVESTMENT_LIMIT_REQUESTS_V1, {
        params: removeEmptyValueFromObject(params),
      })
      return {
        data: Array.isArray(response.data?.data) ? response.data.data : [],
        total: typeof response.data?.total === 'number' ? response.data.total : 0,
        status: response.status,
      }
    } catch (error: any) {
      return {
        data: [],
        total: 0,
        status: error?.response?.status ?? 500,
        message: error?.response?.data?.message,
      }
    }
  },

  getById: async (
    id: string,
  ): Promise<{
    request: InvestmentLimitRequestDetail | null
    status: number
    code?: string
    message?: string
  }> => {
    try {
      const response = await axiosInstance.get<InvestmentLimitRequestDetail>(
        GET_INVESTMENT_LIMIT_REQUEST_V1(id),
      )
      return {
        request: response.data,
        status: response.status,
      }
    } catch (error: any) {
      return {
        request: null,
        status: error?.response?.status ?? 500,
        code: error?.response?.data?.code,
        message: error?.response?.data?.message,
      }
    }
  },

  review: async (
    id: string,
    payload: InvestmentLimitRequestReviewPayload,
  ): Promise<{
    result: InvestmentLimitRequestReviewResult | null
    status: number
    code?: string
    message?: string
  }> => {
    try {
      const response = await axiosInstance.patch<InvestmentLimitRequestReviewResult>(
        UPDATE_INVESTMENT_LIMIT_REQUEST_V1(id),
        payload,
      )
      return {
        result: response.data,
        status: response.status,
      }
    } catch (error: any) {
      return {
        result: null,
        status: error?.response?.status ?? 500,
        code: error?.response?.data?.code,
        message: error?.response?.data?.message,
      }
    }
  },
}
